// extracted by mini-css-extract-plugin
export default {"container":"Numbers_container__u5+Di","number":"Numbers_number__xpFPd","num":"Numbers_num__qsF1Z","title":"Numbers_title__OmA1P"};